// extracted by mini-css-extract-plugin
export default {"container":"A3-z","heading":"B3-z","links":"C3-z","copy":"D3-z","subCopy":"E3-z","linksLeft":"F3-z","linksCenter":"G3-z","linksRight":"H3-z","link":"I3-z","onlyLink":"J3-z"};